<template>
  <div v-show="isOpen" class="uploads__list upload-progress">
    <button class="button hide" @click="onHideClicked">
      <i class="fa fa-times" aria-hidden="true" />
    </button>
    <h3 class="upload-progress__header">Current uploads</h3>
    <template v-if="uploads.length">
      <ProgressBar
        v-for="upload in uploads"
        :key="upload.id"
        :file-name="upload.fileName"
        :progress="upload.fileProgress"
        :status="upload.status"
        @stop-clicked="onStopUploadClicked($event, upload.id)"
        @resume-clicked="onResumeUploadClicked($event, upload.id)"
        @pause-clicked="onPauseUploadClicked($event, upload.id)"
        @retry-clicked="onRetryUploadClicked($event, upload.id)"
        @remove-clicked="onRemoveClicked($event, upload.id)"
      />
    </template>
    <p v-else class="upload-progress__no-uploads">No uploading files</p>
  </div>
</template>

<script>
import ProgressBar from './ProgressBar';

export default {
  name: 'UploadsList',

  components: {
    ProgressBar,
  },

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    uploads: {
      type: Array,
      required: true,
    },
  },

  methods: {
    onHideClicked() {
      this.$emit('hide');
    },
    onStopUploadClicked(event, id) {
      this.$emit('stop', id);
    },
    onResumeUploadClicked(event, id) {
      this.$emit('resume', id);
    },
    onPauseUploadClicked(event, id) {
      this.$emit('pause', id);
    },
    onRetryUploadClicked(event, id) {
      this.$emit('retry', id);
    },
    onRemoveClicked(event, id) {
      this.$emit('remove', id);
    },
  },
};
</script>




// WEBPACK FOOTER //
// UploadsList.vue?96b05bf2